export const lastUpdated = 'Dec. 16, 2022 at 10:51 p.m.';

export const articlesSR = [

  'Access needs and reasonable accommodations',
  'Anti-bullying and respectful work environment',
  'Appointment notification',
  'Appointment security',
  'Childcare',
  'Community safety',
  'Defined contribution and university retirement plan(s)',
  'Discipline and dismissal',
  'Duration',
  'Emergency layoff',
  'Employment file and evaluations',
  'Grievance and arbitration',
  'Health and safety',
  'Health benefits',
  'Holidays',
  'Housing',
  'Immigration',
  'Labor-management meetings',
  'Layoffs',
  'Leaves',
  'Management and academic rights',
  'Nondiscrimination in employment',
  'No strikes',
  'Parking and transit',
  'Past practices',
  'Posting',
  'Recognition',
  'Relocation benefits',
  'Severability',
  'Training',
  'Transitional funding',
  'Travel',
  'Tuition and fee remission',
  'Union access and rights',
  'Union security',
  'Vacation and personal time off',
  'Wages',
  'Waiver',
  'Work-incurred injury or illness',
  'Workload, time and effort',
  'Workplace safety and diversity',
  'Workspace materials and support',
  'Summer support fund side letter',
  'Joint labor management committee side letter',
  'Berkeley side letter',
  'UCSF side letter',
  'Arbitrator panel',
  'Ground rules',
  'Work-incurred injury or illness side letter',
  'Appendix XX',
  'Union security side letter',
  'Leaves side letter',

];

const accessNeedsProposals = [

  {
    name: 'Tentative agreement | Oct. 31, 2022',
    link: 'https://drive.google.com/file/d/1Kll6T7rP8BdiKI22VlpBH055od_ExC0f/view?usp=share_link',
    color: 'success',
  },

];

const respectfulProposals = [

  {
    name: 'Tentative agreement | Oct. 6, 2022',
    link: 'https://drive.google.com/file/d/196P8SFjW5hvrgNowV7KGvALmSs2mAxpv/view?usp=sharing',
    color: 'success',
  },
];

const AppointmentnotificationProposals = [

  {
    name: 'Tentative agreement | Nov. 20, 2022',
    link: 'https://drive.google.com/file/d/1Fzc-2nvuTUUCLQj2HGvVNtyragrF_UdC/view?usp=share_link',
    color: 'success',
  },
];

const AppointmentsecurityProposals = [

  {
    name: 'Tentative agreement | Nov. 11, 2022',
    link: 'https://drive.google.com/file/d/1UT5FwAvdsJkKNh7dZIRk42zfQs3XaQ-o/view?usp=share_link',
    color: 'success',
  },
];

const ChildcareProposals = [

  // {
  //   name: 'Proposal | UAW to UC | April 22, 2022',
  //   link: 'https://drive.google.com/file/d/1TZbqtncHdPYl1x2zjp2mNWnoWkKS-1Lv/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 13, 2022',
  //   link: 'https://drive.google.com/file/d/16NX19Bic1MKImLUNQS04SOkj2IZ4R7DI/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1yTOQQh1s_R3LIW5rvw928UtjSsuiK43O/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 16, 2022',
  //   link: 'https://drive.google.com/file/d/11A7HmQutdrGPxDSbQJXRmTQrRTZAGa8Q/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/15PP8ak90i0SyNcNDKmDQ6I7PHVXU4-Zl/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-ADrXkZhp8BEhuicapXgyG49zFlodtrq/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1oO3MLkQnQ-iSm15HpapUk0NMjKzeHXPc/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1qQsPoWG7KBna9_i2WIVON-iTIu-Drq8k/view?usp=sharing',
    color: 'success',
  },
];

const communitysafetyProposals = [

  {
    name: 'Proposal | UAW to UC | Sept. 21, 2022',
    link: 'https://drive.google.com/file/d/103xbSowGfFVICduoKvravDOZuAVDBHHV/view',
    color: 'secondary',
  },
];

const DefinedcontributionProposals = [

  {
    name: 'Tentative agreement | Nov. 11, 2022',
    link: 'https://drive.google.com/file/d/1JuK52i5jNQV6eZAAK22sywjJvHacXT6z/view?usp=share_link',
    color: 'success',
  },
];

const disciplineProposals = [

  // {
  //   name: 'Proposal | UAW to UC | April 29, 2022',
  //   link: 'https://drive.google.com/file/d/1rbVJ9ZUw9ZT813E-sA-IbxFz2z6DxRXr/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 15, 2022',
  //   link: 'https://drive.google.com/file/d/1v97LYkhpyFrecVGCu1Hf79q-9_mRhegY/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | June 22, 2022',
  //   link: 'https://drive.google.com/file/d/1PKWlX2GYYn8jquxCjwN0njkglFSr18SW/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 29, 2022',
  //   link: 'https://drive.google.com/file/d/1aqaYfDBqDIx3ks8hP6OIUc7ddt_nB52b/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | July 13, 2022',
  //   link: 'https://drive.google.com/file/d/1_rtepzJUnxXxszMSyJa9UYdMn_as3cXp/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Sept. 22, 2022',
  //   link: 'https://drive.google.com/file/d/1GIiWqmhbBeN1XPQSuMi8fuF0IgbIVt9n/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct. 6, 2022',
  //   link: 'https://drive.google.com/file/d/1wV6Xahi8wcmJTNUH6kMazvceYzrq_e2J/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 7, 2022',
  //   link: 'https://drive.google.com/file/d/15Kat3YzJdAIWqWTZGDd5g9fR3pYOq5zW/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1Ca8ryV0iJIV-zsKmBCAZwG0eWHewCYo2/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1rJjLVFn1IDnZOdLHPQNiXm6sZqnYyoFJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1CzXhuq1JD2vqH5N_xat9nDENth02XxiU/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1u9B4_TEovPIwIHCwecxnWrSBWRaSI3sq/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 14, 2022',
  //   link: 'https://drive.google.com/file/d/1pkdxBEW0shilhYO793ZIILjqnLg4XPn7/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-ADrXkZhp8BEhuicapXgyG49zFlodtrq/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1gYo5GnUEGhmWeA08HeIcgNCJ-g3DyAwJ/view?usp=sharing',
    color: 'success',
  },
];

const durationProposals = [

  // {
  //   name: 'Proposal | UC to UAW | April 15, 2022',
  //   link: 'https://drive.google.com/file/d/1-MMZldyxZyBTZ8_i_oSEoh3UUsDyXCxk/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 13, 2022',
  //   link: 'https://drive.google.com/file/d/16NX19Bic1MKImLUNQS04SOkj2IZ4R7DI/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 16, 2022',
  //   link: 'https://drive.google.com/file/d/11A7HmQutdrGPxDSbQJXRmTQrRTZAGa8Q/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/13YWTunKjFTt80P2StKbbXJekUTQe8-vi/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1yu2PGkaUpXowaD563LuvSUulHZr-e7D1/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-ADrXkZhp8BEhuicapXgyG49zFlodtrq/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1sg5pm8yIYNp58kBZM4EtDTDHaehISOZM/view?usp=sharing',
    color: 'success',
  },
];

const emergencyLayoffProposals = [
  {
    name: 'Tentative agreement | Nov. 11, 2022',
    link: 'https://drive.google.com/file/d/1UT5FwAvdsJkKNh7dZIRk42zfQs3XaQ-o/view?usp=share_link',
    color: 'success',
  },
];

const employmentfileProposals = [
  {
    name: 'Tentative agreement | May 27, 2022',
    link: 'https://drive.google.com/file/d/1b9MvsKGOfm5yq-d3cAxsX3IAWykDoD7P/view?usp=sharing',
    color: 'success',
  },
];

const grievanceProposals = [
  {
    name: 'Tentative agreement | Nov. 13, 2022',
    link: 'https://drive.google.com/file/d/1OvbpoLiryXuieH8Qa8nLp67PW9ugC-5Z/view?usp=share_link',
    color: 'success',
  },
];

const healthSafetyProposals = [
  {
    name: 'Tentative agreement | Oct. 6, 2022',
    link: 'https://drive.google.com/file/d/11fjyBjQlU-WRrz_LEkTtRZlnDnZLvcZM/view?usp=sharing',
    color: 'success',
  },
];

const healthBenefitsProposals = [
  // {
  //   name: 'Proposal | UC to UAW | April 15, 2022',
  //   link: 'https://drive.google.com/file/d/1-MMZldyxZyBTZ8_i_oSEoh3UUsDyXCxk/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | April 29, 2022',
  //   link: 'https://drive.google.com/file/d/11-708mwvTgFBf8TrANk6FTez36-vOaev/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 16, 2022',
  //   link: 'https://drive.google.com/file/d/11A7HmQutdrGPxDSbQJXRmTQrRTZAGa8Q/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/1QwKGw7jeLjFx2_q6lhiIw_C87Q8CIjQr/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-ADrXkZhp8BEhuicapXgyG49zFlodtrq/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1eERdAR8bZzCuDcRWQvcrcMUxGUS6oVF7/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1GF_svZv0cl0XaIWRgVxMp1dB5Kk3225b/view?usp=sharing',
    color: 'success',
  },
];

const holidaysProposals = [
  {
    name: 'Tentative agreement | Oct. 6, 2022',
    link: 'https://drive.google.com/file/d/1cgE7MvZYOak-nXqGIan52AYv80nMZfIs/view?usp=sharing',
    color: 'success',
  },
];

const housingProposals = [
  // {
  //   name: 'Proposal | UAW to UC | July 20, 2022',
  //   link: 'https://drive.google.com/file/d/1Vzn6FzDlkQTjT8lHidqswA2fei_FTn9A/view?usp=drivesdk',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1qKWcHPLwmrnQDAhI_GO3fC5-tuVLQfqn/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1xj9grVEEoNwf50O4xzLjGip_evof_sem/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/12hAMj4r5DAo9vLlc_Z5Y304eQocAPHnK/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
  //   color: 'secondary',
  // },
];

const internationalProposals = [
  {
    name: 'Tentative agreement | Nov. 20, 2022',
    link: 'https://drive.google.com/file/d/1cSOAxOUflHIEOrxC1r2dNq7RwGH2DEMQ/view',
    color: 'success',
  },

];

const laborManagementProposals = [
  {
    name: 'Tentative agreement | May 13, 2022',
    link: 'https://drive.google.com/file/d/1YDmzgEZ_-MgZieFwhpUFlrf2Ok-ILbVX/view',
    color: 'success',
  },
];

const Layoffsproposal = [
];

const leavesProposals = [

  // {
  //   name: 'Proposal | UAW to UC | April 15, 2022',
  //   link: 'https://drive.google.com/file/d/1FaCDsBoFDxNZz4xoAqqjQcvrG_Pwygp8/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Sept. 22, 2022',
  //   link: 'https://drive.google.com/file/d/1VqdGUttaTiEdgRNbeTUga9EXX-yP5OCk/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Sept. 22, 2022',
  //   link: 'https://drive.google.com/file/d/1BaQ8Mk5ETK5CoiWAj1G_eijS7s8WwOpp/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 13, 2022',
  //   link: 'https://drive.google.com/file/d/14p2zpYrxNqN9FqZ72Z7kBntWZKQRtF_J/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 13, 2022',
  //   link: 'https://drive.google.com/file/d/16NX19Bic1MKImLUNQS04SOkj2IZ4R7DI/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1QMdRaTRVYVfnIBhWvfaJ02a3Ca5xcZ6h/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/12YQS7gukWIYbGuCrB5mTzSotFILgS3D_/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1lSpz_fHJGCZeEDdJksHyxBjZ4NS6QqtG/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/12YQS7gukWIYbGuCrB5mTzSotFILgS3D_/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 16, 2022',
  //   link: 'https://drive.google.com/file/d/11A7HmQutdrGPxDSbQJXRmTQrRTZAGa8Q/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1KwBtB6cu0JX8kj_lDdnN8gBd1lZZ94Su/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1yu2PGkaUpXowaD563LuvSUulHZr-e7D1/view?usp=sharing',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 30, 2022',
    link: 'https://drive.google.com/file/d/1oCtP56ILBPlZj-CRQpaTKGfAf5if-FcQ/view?usp=sharing',
    color: 'success',
  },

];

const ManagementrightsProposal = [
  // {
  //   name: 'Proposal | UAW to UC | Sept. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1EjfK_cqHgpmWCPP_PLY5iPjetLKTejhi/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct. 6, 2022',
  //   link: 'https://drive.google.com/file/d/1wV6Xahi8wcmJTNUH6kMazvceYzrq_e2J/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 7, 2022',
  //   link: 'https://drive.google.com/file/d/15OrK0LlHdgomA6_dseCIn7NeAp3UciSw/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1eScS_yU1At-5dKAxDo7C6pYbtFc0C-ds/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1rJjLVFn1IDnZOdLHPQNiXm6sZqnYyoFJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1b_pld89eZGoZ5l96o5neIRFF1KdA0n8r/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1CzXhuq1JD2vqH5N_xat9nDENth02XxiU/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/14w4nmFIR8b8E1E4CXGmcj_hv2R6qpsM7/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 14, 2022',
  //   link: 'https://drive.google.com/file/d/1pkdxBEW0shilhYO793ZIILjqnLg4XPn7/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal| UC to UAW | Nov. 16, 2022',
  //   link: 'https://drive.google.com/file/d/1kMiTU6Edam0GLYldVeB31HdBN09BH0R5/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1ju26XK-GcDPmvMevFfGD_lRzyctz2zNh/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1qKWcHPLwmrnQDAhI_GO3fC5-tuVLQfqn/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/13JAXa13M2pTuA_0vap8sdNMsIqrxCloQ/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1yu2PGkaUpXowaD563LuvSUulHZr-e7D1/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/134-6UrXCeI2nG8aOapya7gvS2on_BKmt/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-ADrXkZhp8BEhuicapXgyG49zFlodtrq/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1r4g1db06wDLQAf5n-vXL7wKVtFbJivJM/view?usp=sharing',
    color: 'success',
  },
];

const nondiscriminationProposals = [

  {
    name: 'Tentative agreement | Oct. 6, 2022',
    link: 'https://drive.google.com/file/d/193-iGpd4c5vWPmV_6jFjd-oECnT4NSN_/view?usp=sharing',
    color: 'success',
  },
];

const noStrikesProposals = [
  // {
  //   name: 'Proposal | UC to UAW | Aug. 26, 2022',
  //   link: 'https://drive.google.com/file/d/1LhD9zS5hCJmA05GbxqUxw1TYxTtBt1Tw/view?usp=drivesdk',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1mVkuEjD98-GkshpAfapbNCJrbcqc-Ohl/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1WzhZHDBkJVT9f7FnLKCgenBn3uvAdMiM/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/1-sv3S-rUMTVPDpWCE2Okmr5Cez6EoWG1/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-ADrXkZhp8BEhuicapXgyG49zFlodtrq/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/16R6CKsvepJ49vUR9w1USIx78xKRLnSF7/view?usp=sharing',
    color: 'success',
  },
];

const parkingTransitProposals = [
  // {
  //   name: 'Proposal | UAW to UC | May 13, 2022',
  //   link: 'https://drive.google.com/file/d/1kJ8LY2hVBRaRy143K2mVKATY0CYosozX/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 15, 2022',
  //   link: 'https://drive.google.com/file/d/1EilC0VFu31-BAXCjoGO30xitaetPkPqn/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Aug. 5, 2022',
  //   link: 'https://drive.google.com/file/d/1phxD1-NlZm8pDJurSJ8xY8-hW1xHXH7L/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Aug. 26, 2022',
  //   link: 'https://drive.google.com/file/d/1LhD9zS5hCJmA05GbxqUxw1TYxTtBt1Tw/view?usp=drivesdk',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 13, 2022',
  //   link: 'https://drive.google.com/file/d/16NX19Bic1MKImLUNQS04SOkj2IZ4R7DI/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Supposal | UC to UAW | Oct. 31, 2022',
  //   link: 'https://drive.google.com/file/d/1MOPmhUgNIMUfRK-aygtaUw4cXosQElMW/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 7, 2022',
  //   link: 'https://drive.google.com/file/d/1CfJ55HuBwNxR5ETo5WJzE67eh7Guvpba/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1mCtalT4c65-pzAHFx8viszDYaf5aCdKe/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 14, 2022',
  //   link: 'https://drive.google.com/file/d/1uaibDb_8YzVQ2CbrftCuGVs1dldjWuBq/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 16, 2022',
  //   link: 'https://drive.google.com/file/d/1gHFZaa5Wy_6FJH_Fx49BvHhxFkfwKKsO/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 16, 2022',
  //   link: 'https://drive.google.com/file/d/1MrdMP15ePl8x0KX5uxL_RYaPu2WaM03f/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 16, 2022',
  //   link: 'https://drive.google.com/file/d/11A7HmQutdrGPxDSbQJXRmTQrRTZAGa8Q/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 16, 2022',
  //   link: 'https://drive.google.com/file/d/1HpQuXrfgGnZclaGajq30PAUxpIy0-mzV/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1Y4ZeuT8B-o1Bmwzm05t7YsZLm3sMJWCe/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 21, 2022',
  //   link: 'https://drive.google.com/file/d/1nJm9OEiZFW3hin9UyR9aDpmolf8k1rEG/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 22, 2022',
  //   link: 'https://drive.google.com/file/d/1sYDctuLU9OpcjUldsS-A5ysMFlqeN9S5/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 23, 2022',
  //   link: 'https://drive.google.com/file/d/1qLJXyVJuM076cSts-3YLymvmSLs4gJHs/view?usp=sharing',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 30, 2022',
    link: 'https://drive.google.com/file/d/1JsLY0NUu7rU7dAVKDDp5AVPaTkqsa5o7/view?usp=sharing',
    color: 'success',
  },
];

const pastPracticesProposals = [
  {
    name: 'Tentative agreement | Aug. 5, 2022',
    link: 'https://drive.google.com/file/d/1Rid-edKmurihOO6kn34wWZ8k5NKcUA-d/view?usp=sharing',
    color: 'success',
  },
];

const postingProposals = [

];

const recognitionProposals = [
  // {
  //   name: 'Proposal | UAW to UC | April 5, 2022',
  //   link: 'https://drive.google.com/file/d/18mu5dHCXSTT2lZeKj_leFDXYkWJGdP9L/view?usp=drivesdk',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | May 20, 2022',
  //   link: 'https://drive.google.com/file/d/1vAIc9XIVTvuMRKFcrcsS2EdBpnXgEBtT/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Sept. 15, 2022',
  //   link: 'https://drive.google.com/file/d/1eq-o9ApSDRodaiFi_bx7oAfnzlKvlEYe/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Sept. 15, 2022',
  //   link: 'https://drive.google.com/file/d/1N5eyeLnNg5FDT-qEdTs2AN12FGyv9WUi/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct. 6, 2022',
  //   link: 'https://drive.google.com/file/d/1wV6Xahi8wcmJTNUH6kMazvceYzrq_e2J/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1eScS_yU1At-5dKAxDo7C6pYbtFc0C-ds/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1vsZljsro30kvlNcOQL7LdtoX88jST5xM/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1rJjLVFn1IDnZOdLHPQNiXm6sZqnYyoFJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1CzXhuq1JD2vqH5N_xat9nDENth02XxiU/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1m_sgiMfEN0xWuiyvlxRTcKh01i6tYDAM/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 14, 2022',
  //   link: 'https://drive.google.com/file/d/1pkdxBEW0shilhYO793ZIILjqnLg4XPn7/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-ADrXkZhp8BEhuicapXgyG49zFlodtrq/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1zgK1Xzjcj2d0GIUZI3IpJKWK26ofRv7M/view?usp=sharing',
    color: 'success',
  },
];

const relocationBenefitProposals = [
  // {
  //   name: 'Proposal | UAW to UC | May 27, 2022',
  //   link: 'https://drive.google.com/file/d/14T20XhK2O2j-ETblZUZ4tgpS-0A7FjoV/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Aug. 26, 2022',
  //   link: 'https://drive.google.com/file/d/1LhD9zS5hCJmA05GbxqUxw1TYxTtBt1Tw/view?usp=drivesdk',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
  //   color: 'secondary',
  // },
];

const severabilityProposals = [
  {
    name: 'Tentative agreement | May 13, 2022',
    link: 'https://drive.google.com/file/d/1i053UnDwPKqpgJywW4PFKNLKYNOJ8cQJ/view?usp=sharing',
    color: 'success',
  },
];

const TrainingProposals = [
  {
    name: 'Tentative agreement | July 21, 2022',
    link: 'https://drive.google.com/file/d/13ih6HhoB-oAQcDpzhE1Hq5zDn4annl9C/view?usp=sharing',
    color: 'success',
  },
];

const TransitionalfundingProposals = [
  // {
  //   name: 'Proposal | UAW to UC | July 13, 2022',
  //   link: 'https://drive.google.com/file/d/1g6AucdOdwxklyJAK5TdhS9Wo1VO1e6FL/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
  //   color: 'secondary',
  // },
];

const travelProposals = [
  {
    name: 'Tentative agreement | May 27, 2022',
    link: 'https://drive.google.com/file/d/1fGuGLf8cFhJsyJryUiaSE-gzDnaWe0Zb/view?usp=sharing',
    color: 'success',
  },
];

const TuitionremissionProposals = [
  // {
  //   name: 'Proposal | UAW to UC | May 20, 2022',
  //   link: 'https://drive.google.com/file/d/1_UHMpGPNb0lZC2wFFDLRZBw-uHSMz_vY/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1YtgQhlSAHcYL9OA79ZppyZapTGybo_zP/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 13, 2022',
  //   link: 'https://drive.google.com/file/d/16NX19Bic1MKImLUNQS04SOkj2IZ4R7DI/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 16, 2022',
  //   link: 'https://drive.google.com/file/d/11A7HmQutdrGPxDSbQJXRmTQrRTZAGa8Q/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/19sQ-RbiQK0Mf4qGRyEWRVKTdhwq8gd9o/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-ADrXkZhp8BEhuicapXgyG49zFlodtrq/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1rr3Meu0T72KG7FBavuDOO6xD_09rtJte/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1vNzIyCr0Wnd2XnlhjQ4ogM8jViukJ-ba/view?usp=sharing',
    color: 'success',
  },

];

const unionAccessProposals = [
  {
    name: 'Tentative agreement | Nov. 14, 2022',
    link: 'https://drive.google.com/file/d/1XLSDZEin8BTUQQjrjIme7GEu7KUOkiTl/view?usp=share_link',
    color: 'success',
  },
];

const unionSecurityProposals = [
  {
    name: 'Tentative agreement | Nov, 14, 2022',
    link: 'https://drive.google.com/file/d/1oOLHG7FhE2ezoEQaV_PwkBHiLVkLaeRM/view',
    color: 'success',
  },
];

const appendixXXProposals = [
  {
    name: 'Tentative agreement | Nov, 16, 2022',
    link: 'https://drive.google.com/file/d/1VaYyK-nSHMXoH1EbcU_qYLvXVMbInxvo/view',
    color: 'success',
  },
];

const unionSecSideLetterProposals = [
  {
    name: 'Tentative agreement | Nov, 16, 2022',
    link: 'https://drive.google.com/file/d/1srJO67U5kTR2kZDCb8tyq4lDSwV_n_MD/view?usp=share_link',
    color: 'success',
  },
];

const VacationProposals = [
  // {
  //   name: 'Proposal | UAW to UC | June 22, 2022',
  //   link: 'https://drive.google.com/file/d/15yG-xNAf55RuDR1w4UwGXbLWx_hL1SUQ/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Sept. 22, 2022',
  //   link: 'https://drive.google.com/file/d/1BaQ8Mk5ETK5CoiWAj1G_eijS7s8WwOpp/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Spet. 22, 2022',
  //   link: 'https://drive.google.com/file/d/1nR7eNuG4WtbY-CAOoKB2tWhwXwWVZaUt/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1IvqaBT1Rv7kWdmxRr-CyKnRyGxhVhESJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1Bi21OyndzYbMvceGnZ1_wDgPQbiY3iLh/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1GvuwWIPLPDy25ftfLC4mDLKls-Z1QxLd/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1GvuwWIPLPDy25ftfLC4mDLKls-Z1QxLd/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 16, 2022',
  //   link: 'https://drive.google.com/file/d/1-lzNLExirVYGFd2MOC6k5iHdn_3hHkWe/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1mDHdiQTCc8yHTcTnAWgrV3bQO7U5Qvj3/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 30, 2022',
    link: 'https://drive.google.com/file/d/1s-sug1cpa2LoscsbDkuPu9hZ3bnwxFLz/view?usp=sharing',
    color: 'success',
  },

];

const wagesProposals = [
  {
    name: 'Proposal | UAW to UC | July 20, 2022',
    link: 'https://drive.google.com/file/d/1EUyJAQht4xTOtNdIOgbPt4_OHTsj2kxa/view?usp=drivesdk',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | Oct. 13, 2022',
    link: 'https://drive.google.com/file/d/16NX19Bic1MKImLUNQS04SOkj2IZ4R7DI/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Oct. 13, 2022',
    link: 'https://drive.google.com/file/d/1UsqpFn0EOfX4Tvg7uTSapA4KFYRz1mpt/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UAW to UC | Oct. 31, 2022',
    link: 'https://drive.google.com/file/d/1Wpp8qPMmBAcKS3_gemQAKaOdkqxuYHMa/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Oct. 13, 2022',
    link: 'https://drive.google.com/file/d/11A7HmQutdrGPxDSbQJXRmTQrRTZAGa8Q/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Nov. 16, 2022',
    link: 'https://drive.google.com/file/d/1hTf0HlZojvU-i2Fg5FU5iJctXQtSAWEd/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Nov. 16, 2022',
    link: 'https://drive.google.com/file/d/1vimpvEPnVdehhIC0risqKM27tdtRsqJW/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UAW to UC | Nov. 17, 2022',
    link: 'https://drive.google.com/file/d/1TxhrKrRF6ne7jmtR9pqzRlNdPe59jvsT/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Package | UAW to UC | Nov. 17, 2022',
    link: 'https://drive.google.com/file/d/1qKWcHPLwmrnQDAhI_GO3fC5-tuVLQfqn/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Nov. 29, 2022',
    link: 'https://drive.google.com/file/d/1M5-_6GelxoVislToU5NQ-OcSoPhvWC51/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Nov. 29, 2022',
    link: 'https://drive.google.com/file/d/1mcVejrnDGviFhXwUXcqkrJDo64t56BiG/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | Nov. 29, 2022',
    link: 'https://drive.google.com/file/d/1yu2PGkaUpXowaD563LuvSUulHZr-e7D1/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UAW to UC | Nov. 30, 2022',
    link: 'https://drive.google.com/file/d/1Cd0DSV_rhqC9t_-8uBOmE5y8xBWUWNhc/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Package | UAW to UC | Nov. 30, 2022',
    link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Dec. 2, 2022',
    link: 'https://drive.google.com/file/d/1FveulJ47nkcBUbSd4UczKuGnFM7A4snj/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Dec. 2, 2022',
    link: 'https://drive.google.com/file/d/1n4tx-25wXu__rK4-apsRevJAyU0s4XKd/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | Dec. 2, 2022',
    link: 'https://drive.google.com/file/d/1-ADrXkZhp8BEhuicapXgyG49zFlodtrq/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UAW to UC | Dec. 8, 2022',
    link: 'https://drive.google.com/file/d/1sohvxuhgruJJq28r-jeP5n589LLQtV53/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Package | UAW to UC | Dec. 8, 2022',
    link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1VEZnkehWnijJhPQeuKxCBiEImH18mHbt/view?usp=sharing',
    color: 'success',
  },

];

const waiverProposals = [
  {
    name: 'Tentative agreement | Aug. 5, 2022',
    link: 'https://drive.google.com/file/d/1vInssHn7HeTElxmbt2MAMpDTFBXyEvIT/view',
    color: 'success',
  },
];

const WorkinjuryProposal = [

  {
    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/1PQ8Fm5C7KsVPbIiN87v2NI0-upxpsrwO/view',
    color: 'success',
  },
];

const workIncurredSideLetterProposals = [

  {
    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/1ujhomfoA00VesjEWfUqslBZfIcO1V_2I/view?usp=share_link',
    color: 'success',
  },
];

const workloadProposals = [

  {
    name: 'Tentative agreement | Oct. 21, 2022',
    link: 'https://drive.google.com/file/d/1oUTsiuwuXrOh2c_vROs7eGdE4OQ4yhVi/view?usp=share_link',
    color: 'success',
  },
];

const workplaceSafetyProposals = [

  // {
  //   name: 'Proposal | UAW to UC | April 29, 2022',
  //   link: 'https://drive.google.com/file/d/1KDJKxa-y0l_QiHM4baZGANyMg9oj4BNR/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/13YaXFfsD4GunTQFVPDTgqvDe5j_C4tEJ/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
  //   color: 'secondary',
  // },

];

const workspaceMaterialsProposals = [
  {
    name: 'Tentative agreement | April 29, 2022',
    link: 'https://drive.google.com/file/d/1LUwYeSTSlrGIPddX1o4VLxPqxgQXmgsm/view?usp=sharing',
    color: 'success',
  },
];

const jlmProposals = [
  {
    name: 'Tentative agreement | Oct. 31, 2022',
    link: 'https://drive.google.com/file/d/1hp9_BxN33ZkWdiQ2ZxrCv4NdAOJFqGwC/view?usp=share_link',
    color: 'success',
  },
];

const arbitratorPanelProposals = [
  {
    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/1YGhx0k1ab78DelkUJJHoCUt6-SoPKjRG/view?usp=sharing',
    color: 'success',
  },
];

const groundRulesProposals = [

  {
    name: 'Tentative agreement | April 22, 2022',
    link: 'https://drive.google.com/file/d/15h5mioePNsQ6FG7iEszc1COClyi_d0OO/view?usp=sharing',
    color: 'success',
  },
];

const summerSupportProposals = [

  // {
  //   name: 'Proposal | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1A3-MSUl6EONlN1y4qh4eRGZ96F3EANar/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-ADrXkZhp8BEhuicapXgyG49zFlodtrq/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1GKTEbFmlkRMd2RBR3khB1bSK0Utb5zxc/view?usp=share_link',
  //   color: 'secondary',
  // },

];

const berkeleySideLetter = [

  // {
  //   name: 'Proposal | UC to UAW | Dec. 4, 2022',
  //   link: 'https://drive.google.com/file/d/1xQ3p8NZ17nZ5RgI5lZ1wPbn5fkoculqH/view',
  //   color: 'secondary',
  // },

];

const sideLetterUCSF = [

  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1lzC3k6ZMX4HEPaIQkkVBVTprm2WFZ3qX/view?usp=sharing',
    color: 'success',
  },

];

const leavesSideLetter = [

  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1Z413r9ZE6Yr8hwRocBEbQaIlC5ITuw0D/view?usp=sharing',
    color: 'success',
  },

];

export const infoSR = {

  'Access needs and reasonable accommodations': {

    proposals: accessNeedsProposals,
    intro: 'SRU-UAW and the UC system arrived at a tentative agreement on access needs Oct. 31, 2022, as part of a package of proposals.',

  },
  'Anti-bullying and respectful work environment': {

    proposals: respectfulProposals,
    intro: 'The union and the UC system signed a tentative agreement on anti-bullying Sept. 29, 2022. The agreement provides examples of abusive conduct, which should be reported to the UC system and may result in an investigation.',

  },
  'Appointment notification': {

    proposals: AppointmentnotificationProposals,
    intro: 'On Nov. 20, 2022, a proposal for the appointment notification article was tentatively agreed upon.',

  },
  'Appointment security': {

    proposals: AppointmentsecurityProposals,
    intro: 'On Nov. 11, 2022, a proposal for the appointment security article was tentatively agreed upon.',

  },
  Childcare: {

    proposals: ChildcareProposals,
    intro: 'On April 22, 2022, SRU-UAW proposed that the UC system reimburse SRs for child care costs up to $6000 per quarter and $9000 per semester. In response, the UC system offered maximum reimbursements of less than $6000 per year. The Dec. 16 tentative agreement guarantees $1400 per fiscal quarter starting Oct. 1, 2024.',

  },
  'Community safety': {

    proposals: communitysafetyProposals,
    intro: 'Despite past negotiations, the tentative contract agreement does not contain this article.',

  },
  'Defined contribution and university retirement plan(s)': {

    proposals: DefinedcontributionProposals,
    intro: 'SRU-UAW’s and the UC system’s negotiations on SRs’ retirement plans arrived at a tentative agreement Nov. 11, 2022.',

  },
  'Discipline and dismissal': {

    proposals: disciplineProposals,
    intro: 'Negotiations for the procedures and grounds for disciplining and dismissing SRs reached a tentative agreement.',

  },
  Duration: {

    proposals: durationProposals,
    intro: 'The contract should terminate May 31, 2025, by the tentative agreement on this new contract.',

  },
  'Emergency layoff': {

    proposals: emergencyLayoffProposals,
    intro: 'The Nov. 11, 2022, tentative agreement does not require the UC system to pay SRs during an emergency layoff.',

  },
  'Employment file and evaluations': {

    proposals: employmentfileProposals,
    intro: 'Employment files and employment evaluations are defined in a tentative agreement from May 27, 2022. The agreement also details how SRs may access them.',

  },
  'Grievance and arbitration': {

    proposals: grievanceProposals,
    intro: 'On Nov. 13, 2022, a proposal for grievances and arbitrations was tentatively agreed upon. This agreement details the processes and guidelines concerning grievances filed against the university.',

  },
  'Health and safety': {

    proposals: healthSafetyProposals,
    intro: 'On Aug. 26, 2022, a proposal for health and safety was tentatively agreed upon This agreement details health and safety procedures that Graduate SR’s must abide by.',

  },
  'Health benefits': {

    proposals: healthBenefitsProposals,
    intro: 'A tentative agreement was reached Dec. 16.',

  },
  Holidays: {

    proposals: holidaysProposals,
    intro: 'On April 22, 2022, a proposal for observed holidays was tentatively agreed upon. This agreement details which days of the year the UC system observes as holidays',

  },
  Housing: {

    proposals: housingProposals,
    intro: 'The UAW withdrew this article by a Dec. 16 tentative agreement.',

  },
  Immigration: {

    proposals: internationalProposals,
    intro: 'The SRU-UAW and the UC system arrived at a tentative agreement Nov. 20, 2022. The tentative agreement provides that the joint labor management committee should discuss issues arising from this article.',

  },
  'Labor-management meetings': {

    proposals: laborManagementProposals,
    intro: 'The SRU-UAW and the UC system have reached a tentative agreement on labor-management meetings. This agreement details the policies pertaining to quarterly system-wide meetings between the SRU-UAW and the University.',

  },
  Layoffs: {

    proposals: Layoffsproposal,
    intro: 'The UC system proposal withdrew its proposal for the layoffs article.',

  },
  Leaves: {

    proposals: leavesProposals,
    intro: 'The tentative agreement details eligibility for and duration of different kinds of leaves.',

  },
  'Management and academic rights': {

    proposals: ManagementrightsProposal,
    intro: 'A tentative agreement was reached Dec. 16.',

  },
  'Nondiscrimination in employment': {

    proposals: nondiscriminationProposals,
    intro: 'The SRU-UAW and the UC system have reached a tentative agreement on the nondiscrimination in employment article Oct. 6, 2022. This agreement lists the forms of discrimination the UC system is prohibited from committing.',

  },
  'No strikes': {
    proposals: noStrikesProposals,
    intro: 'A tentative agreement was reached Dec. 16, prohibiting authorization of strikes by the union.',

  },
  'Parking and transit': {
    proposals: parkingTransitProposals,
    intro: 'On Nov. 30, 2022, negotiations between parties resulted in a tentative agreement on parking and transit policies.',

  },
  'Past practices': {
    proposals: pastPracticesProposals,
    intro: 'The SRU-UAW and the UC system have reached a tentative agreement on past practices as of Aug. 5, 2022.',

  },
  Posting: {
    proposals: postingProposals,
    intro: 'The SRU-UAW withdrew this article Nov. 11, 2022. The union’s April 22, 2022 proposal for the article, however, asked the UC system to post employment opportunities for SRs on campus websites.',

  },
  Recognition: {
    proposals: recognitionProposals,
    intro: 'A tentative agreement reached Dec. 16 determined the groups that should be represented by the SRU-UAW. All are graduate student positions.',

  },
  'Relocation benefits': {
    proposals: relocationBenefitProposals,
    intro: 'The UAW withdrew this article by a Dec. 16 tentative agreement.',

  },
  Severability: {
    proposals: severabilityProposals,
    intro: 'As of May 13, 2022, the SRU-UAW and the UC system reached a tentative agreement on the severability article.',

  },
  Training: {
    proposals: TrainingProposals,
    intro: 'As of July 20, 2022, the SRU-UAW and the UC system tentatively agreed that required training should be on paid time.',

  },
  'Transitional funding': {
    proposals: TransitionalfundingProposals,
    intro: 'The union’s July 13, 2022, proposal pertained to the funds provided to SRs to aid in their transitions from "unhealthy or unproductive research situations." The UAW withdrew this article by a Dec. 16 tentative agreement.',

  },
  Travel: {
    proposals: travelProposals,
    intro: 'As of May 27, 2022, the SRU-UAW and the UC system reached a tentative agreement. The agreement pertains to reimbursements for travel required by SRs’ work-related business.',

  },
  'Tuition and fee remission': {
    proposals: TuitionremissionProposals,
    intro: 'The SRU-UAW and the UC system have yet to reach an agreement on tuition and fee remission.',

  },
  'Union access and rights': {
    proposals: unionAccessProposals,
    intro: 'The SRU-UAW and the UC system reached a tentative agreement on this article Nov. 14, 2022.',

  },
  'Union security': {
    proposals: unionSecurityProposals,
    intro: 'The SRU-UAW and the UC system have reached a tentative agreement on the union security article as of Nov. 14, 2022.',

  },
  'Vacation and personal time off': {
    proposals: VacationProposals,
    intro: 'By a Nov. 30, 2022 tentative agreement, SRs should receive twelve workdays of personal time off per year.',

  },
  Wages: {
    proposals: wagesProposals,
    intro: 'A tentative agreement on the wages article was reached Dec. 16 after more than 15 back-and-forth proposals and packages from both parties. Despite having reached an agreement, the proposal history is included in this tool.',

  },
  Waiver: {
    proposals: waiverProposals,
    intro: 'As of Aug. 5, 2022, the SRU-UAW and the UC system have reached a tentative agreement on the waiver article.',

  },
  'Work-incurred injury or illness': {
    proposals: WorkinjuryProposal,
    intro: 'The SRU-UAW and the UC system reached a tentative agreement on the work-incurred injury or illness article Nov. 18, 2022.',

  },
  'Work-incurred injury or illness side letter': {
    proposals: workIncurredSideLetterProposals,
    intro: 'A tentative agreement on this side letter to the work-incurred injury or illness article was met Nov. 18, 2022.',
  },

  'Appendix XX': {
    proposals: appendixXXProposals,
    intro: 'By the tentative agreement on the union security article, Appendix XX should accompany the membership election form.',

  },
  'Union security side letter': {
    proposals: unionSecSideLetterProposals,
    intro: 'This side letter to the union security article was tentatively agreed upon Nov. 16, 2022.',

  },

  'Workload, time and effort': {
    proposals: workloadProposals,
    intro: 'As of Oct. 18, 2022, the SRU-UAW and the UC system reached a tentative agreement on the workload, time and effort article. It pertains to the workload and responsibilities of SRs.',

  },
  'Workplace safety and diversity': {
    proposals: workplaceSafetyProposals,
    intro: 'The UAW withdrew this article by a Dec. 16 tentative agreement.',

  },
  'Workspace materials and support': {
    proposals: workspaceMaterialsProposals,
    intro: 'The SRU-UAW and the UC system reached a tentative agreement on workspace materials and support April 29, 2022.',

  },
  'Summer support fund side letter': {
    proposals: summerSupportProposals,
    intro: 'Negotiations for this side letter are still in negotiation. The first proposal came from the UC system in December 2022.',
  },

  'Joint labor management committee side letter': {
    proposals: jlmProposals,
    intro: 'As of Oct. 13, 2022, the SRU-UAW and the UC system have reached a tentative agreement on this side letter.',

  },
  'Arbitrator panel': {
    proposals: arbitratorPanelProposals,
    intro: 'As of Nov. 18, 2022, the SRU-UAW and the UC system tentatively agreed on the panel of arbitrators.',

  },
  'Ground rules': {
    proposals: groundRulesProposals,
    intro: 'As of April 22, 2022, the SRU-UAW and the UC system have reached a tentative agreement on five “ground rules” for bargaining.',

  },

  'Berkeley side letter': {
    proposals: berkeleySideLetter,
    intro: 'The first proposal for this side letter was introduced by the UC system Dec. 4, 2022.',

  },
  'UCSF side letter': {
    proposals: sideLetterUCSF,
    intro: 'The first proposal for this side letter was introduced by the UC system Dec. 4, 2022. The side letter saw a tentative agreement shortly after on Dec. 16.',

  },
  'Leaves side letter': {
    proposals: leavesSideLetter,
    intro: 'Language for this side letter on leaves was tentatively agreen upon Dec. 16.',

  },

};
